/**
 * Toast corto a pantalla (fuera de React).
 * Sobrevive al cierre del modal WA/Email: muchos onSend desmontan el modal
 * antes de que se vea el overlay interno.
 */
export function mostrarToastVitalCasa(mensaje, opciones = {}) {
  if (typeof document === "undefined") return;
  const id = "vc-toast-vitalcasa";
  document.getElementById(id)?.remove();

  const tipo = opciones.tipo === "error" ? "error" : "ok";
  const duracionMs = Number.isFinite(opciones.duracionMs) ? opciones.duracionMs : 2000;
  const detalle = opciones.detalle ? String(opciones.detalle).trim() : "";

  const wrap = document.createElement("div");
  wrap.id = id;
  wrap.setAttribute("role", "status");
  wrap.setAttribute("aria-live", "polite");
  wrap.style.cssText = [
    "position:fixed",
    "inset:0",
    "z-index:2147483646",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "padding:24px",
    "pointer-events:none",
    "font-family:system-ui,-apple-system,Segoe UI,sans-serif",
  ].join(";");

  const card = document.createElement("div");
  const ok = tipo === "ok";
  card.style.cssText = [
    "pointer-events:auto",
    "max-width:360px",
    "width:100%",
    "border-radius:14px",
    "padding:18px 22px",
    "text-align:center",
    "box-shadow:0 18px 48px rgba(0,0,0,0.28)",
    ok
      ? "background:#ecfdf5;border:1px solid #a7f3d0;color:#065f46"
      : "background:#fef2f2;border:1px solid #fecaca;color:#991b1b",
  ].join(";");

  const icon = document.createElement("div");
  icon.style.cssText = "font-size:28px;line-height:1;margin-bottom:8px";
  icon.textContent = ok ? "✅" : "⚠️";

  const title = document.createElement("div");
  title.style.cssText = "font-size:15px;font-weight:700;line-height:1.35";
  title.textContent = String(mensaje || (ok ? "Enviado correctamente" : "No se ha podido enviar"));

  card.appendChild(icon);
  card.appendChild(title);
  if (detalle) {
    const sub = document.createElement("div");
    sub.style.cssText =
      "font-size:12px;font-weight:500;line-height:1.4;margin-top:8px;opacity:0.9;white-space:pre-wrap";
    sub.textContent = detalle.length > 160 ? `${detalle.slice(0, 157)}…` : detalle;
    card.appendChild(sub);
  }

  wrap.appendChild(card);
  document.body.appendChild(wrap);

  window.setTimeout(() => {
    try {
      wrap.remove();
    } catch {
      /* ignore */
    }
  }, Math.max(800, duracionMs));
}

/**
 * Feedback al enviar fichas por WhatsApp o email.
 * @param {{ ok: boolean, canal?: 'whatsapp'|'email', count?: number, mensaje?: string }} opts
 */
export function mostrarToastEnvioPropiedades(opts = {}) {
  const ok = !!opts.ok;
  const n = Math.max(0, Number(opts.count) || 0);
  const canal = opts.canal === "email" ? "email" : "whatsapp";
  const una = n === 1;
  const labelCanal = canal === "email" ? "email" : "WhatsApp";

  if (ok) {
    mostrarToastVitalCasa(
      una ? "Propiedad enviada correctamente" : "Propiedades enviadas correctamente",
      { tipo: "ok", duracionMs: 2000 }
    );
    return;
  }

  const detalleRaw = String(opts.mensaje || "").trim();
  let detalle = detalleRaw;
  if (/no conectado|sesión|sesion|QR|escanea|reconect/i.test(detalleRaw)) {
    detalle = detalleRaw;
  } else if (/smtp|correo|email|gmail|outlook|configur/i.test(detalleRaw)) {
    detalle = detalleRaw;
  } else if (detalleRaw) {
    detalle = detalleRaw;
  } else {
    detalle = canal === "email"
      ? "No hay sesión de correo activa o el envío ha fallado. Revisa Configuración → Correo."
      : "No hay sesión de WhatsApp activa o el envío ha fallado. Revisa Configuración → WhatsApp.";
  }

  mostrarToastVitalCasa(
    una
      ? `No se ha podido enviar la propiedad por ${labelCanal}`
      : n > 1
        ? `No se han podido enviar las propiedades por ${labelCanal}`
        : `No se ha podido enviar por ${labelCanal}`,
    { tipo: "error", detalle, duracionMs: 2800 }
  );
}
